// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


Vue.config.productionTip = false
Vue.use(ElementUI);

//引入axios
var axios = require('axios')
Vue.config.productionTip = false
import store from './store'

//引入swiper样式
import "swiper/css/swiper.css";

// 百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'nPlU5tsqxLU0ohj0SkwDilkcb8GG15AT'
})

/*axios.defaults.baseURL = 'http://192.168.1.52:9090';
Vue.prototype.filePathPrefix = 'http://192.168.1.52:9090';*/
// axios.defaults.baseURL = 'http://47.112.159.67:9999/ent-api';
axios.defaults.baseURL = 'http://www.ccxb315.com/api';
Vue.prototype.filePathPrefix = 'http://www.ccxb315.com/api';

Vue.prototype.$axios = axios
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {
      if (store.state.user.username) {
        next()
      } else {
        next({
          path: 'login',
          query: {redirect: to.fullPath}
        })
      }
    } else {
      next()
    }
  }
)
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js